import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowsComponent } from './workflows.component';
import { AppSharedModule } from '../shared/appshared.module';



import { WorkflowsRoutingModule } from './workflows-routing.module';
import { TreeModule } from 'angular-tree-component';
import { TabViewModule } from 'primeng/primeng';
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { WorkflowViewComponent } from './workflow-view/workflow-view.component';
import { BreadcrumbComponent, Breadcrumb, TreeBreadcrumb } from '../shared/custom/breadcrumb/breadcrumb.component';
import { BreadcrumbModule } from '../shared/custom/breadcrumb/breadcrumb.module';
import { ContentRendererComponent } from './content-renderer/content-renderer.component';
import { ImageMapViewerComponent } from './content-renderer/image-map-viewer/image-map-viewer.component';
import { DocumentLinkViewerComponent } from './content-renderer/document-link-viewer/document-link-viewer.component';
import { NodeLinkViewerComponent } from './content-renderer/node-link-viewer/node-link-viewer.component';


@NgModule({
    imports: [
        CommonModule,
        AppSharedModule,
        WorkflowsRoutingModule,
        TreeModule,
        TabViewModule,
        DataTableModule,
        SharedModule,
        BreadcrumbModule
    ],
    declarations: [WorkflowsComponent, WorkflowViewComponent, ContentRendererComponent, ImageMapViewerComponent, DocumentLinkViewerComponent, NodeLinkViewerComponent],
    exports: [BreadcrumbModule, BreadcrumbComponent, ContentRendererComponent, ImageMapViewerComponent, DocumentLinkViewerComponent, NodeLinkViewerComponent] 
})
export class WorkflowsModule { }




// WEBPACK FOOTER //
// ./src/app/workflows/workflows.module.ts